import { useQuery } from '@tanstack/react-query';
import { getFeatureToggles } from 'api/feature-toggling.service';
import { useToast } from 'hooks/ui';
import { useEffect } from 'react';
import { useFeatureTogglesStore } from 'store/feature-toggling';

const FEATURE_TOGGLING_FETCH_ERROR_MESSAGE =
  'Error occurred while fetching feature toggles';

export const useFeatureTogglingGetQuery = () => {
  const { setFeatureToggles, featureToggles } = useFeatureTogglesStore();
  const toast = useToast();

  const { isLoading, data, error } = useQuery({
    queryKey: ['feature-toggling'],
    queryFn: getFeatureToggles,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: 1,
  });

  useEffect(() => {
    if (data) {
      setFeatureToggles(data);
    }
  }, [data, setFeatureToggles]);

  useEffect(() => {
    if (error) {
      setFeatureToggles(null);
      toast.error(FEATURE_TOGGLING_FETCH_ERROR_MESSAGE);
    }
  }, [setFeatureToggles, error, toast]);

  const isReady = !isLoading && featureToggles;

  return { isLoading: !isReady };
};
